import React from "react";
import { useTranslation } from 'react-i18next';

// Previous / Next controls; hidden when everything fits on one page
export default function Pagination({ page, pageCount, onChange }) {
  const { t } = useTranslation();
  if (pageCount <= 1) return null;

  return (
    <div className="flex items-center justify-center gap-3 mt-4 text-sm">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {t("pagination.previous")}
      </button>
      <span>{t("pagination.pageOf", { page, total: pageCount })}</span>
      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page >= pageCount}
        className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {t("pagination.next")}
      </button>
    </div>
  );
}
